import React from "react"
import SideBar from "../../../common/layout/sidebar.component"
import ProductTabs from "../../../common/layout/tabs/products.component"
import GenericListing from "../../../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../../../state/listing/generic-listing"

const BundleListing = () => {
    SideBar.activateMenu("product")

    return (
        <>
            <ProductTabs />
            <GenericListing
                objectType={ObjectType.BUNDLES}
            />
        </>
    )

}

export default BundleListing


// WEBPACK FOOTER //
// ./src/product/bundle/components/BundleListing.tsx